import { action } from 'satcheljs';
import type { TableView } from 'owa-mail-list-store';

export interface MARK_ALL_AS_READ_STORE_UPDATEActionMessage {
    tableView: TableView;
    markAsRead: boolean;
    rowIdsToExclude: string[] | undefined;
}
const defaultExport: (
    tableView: TableView,
    markAsRead: boolean,
    rowIdsToExclude?: string[]
) => MARK_ALL_AS_READ_STORE_UPDATEActionMessage = action(
    'MARK_ALL_AS_READ_STORE_UPDATE',
    (
        tableView: TableView,
        markAsRead: boolean,
        rowIdsToExclude?: string[]
    ): MARK_ALL_AS_READ_STORE_UPDATEActionMessage => ({
        tableView,
        markAsRead,
        rowIdsToExclude,
    })
);
export default defaultExport;
